import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Contact.css";
import { FaPhone, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const CONTACT_LINKS = [
  {
    Icon: FaEnvelope,
    label: "Email",
    value: "royzaou14@gmail.com",
    href: "mailto:royzaou14@gmail.com",
  },
  {
    Icon: FaWhatsapp,
    label: "WhatsApp",
    value: "+961 81 233 235",
    href: "https://wa.me/96181233235",
  },
  {
    Icon: FaPhone,
    label: "Call",
    value: "+961 81 233 235",
    href: "tel:+96181233235",
  },
];

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState(""); // "" | "sending" | "success" | "error"
  const sectionRef = useRef(null);
  const [vis, setVis] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVis(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .sendForm(
        "service_1t9gav4",
        "template_62otomk",
        form.current,
        "iIs8AQySNmtk8Ko03"
      )
      .then(
        () => { setStatus("success"); form.current.reset(); },
        () => setStatus("error")
      );
  };

  return (
    <section className="contact" id="contact" ref={sectionRef}>
      <div className="about-rule" aria-hidden="true" />

      <div className="contact-container">
        {/* ── Header ── */}
        <div className={`contact-header ${vis ? "contact-header--visible" : ""}`}>
          <span className="section-label">// get in touch</span>
          <h2 className="section-title">
            Let's build something <em>great</em><br />together
          </h2>
          <div className="divider" />
          <p className="section-subtitle">
            Have a project in mind or just want to say hello?
            Drop me a message and I'll get back to you shortly.
          </p>

          {/* Contact info cards */}
          <div className="contact-info">
            {CONTACT_LINKS.map(({ Icon, label, value, href }, i) => (
              <a
                key={label}
                href={href}
                className={`contact-info-item ${vis ? "contact-info-item--visible" : ""}`}
                style={{ transitionDelay: `${200 + i * 100}ms` }}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
              >
                <span className="contact-info-icon"><Icon /></span>
                <div>
                  <span className="contact-info-label">{label}</span>
                  <span className="contact-info-value">{value}</span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* ── Form ── */}
        <div className={`contact-form-wrap ${vis ? "contact-form-wrap--visible" : ""}`}>
          <form ref={form} onSubmit={sendEmail} className="contact-form" noValidate>
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="user_name">Name</label>
                <input
                  id="user_name"
                  type="text"
                  name="user_name"
                  placeholder="Enter your full name"
                  required
                  autoComplete="name"
                />
              </div>

              <div className="form-field">
                <label htmlFor="user_email">Email</label>
                <input
                  id="user_email"
                  type="email"
                  name="user_email"
                  placeholder="hello@example.com"
                  required
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="form-field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Tell me about your project..."
                required
                rows={6}
              />
            </div>

            <button
              type="submit"
              className={`contact-submit ${status === "sending" ? "contact-submit--loading" : ""}`}
              disabled={status === "sending"}
            >
              {status === "sending" ? (
                <>
                  <span className="submit-spinner" />
                  Sending…
                </>
              ) : (
                <>
                  Send Message
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <path d="M22 2L11 13"/><path d="M22 2L15 22 11 13 2 9l20-7z"/>
                  </svg>
                </>
              )}
            </button>

            {status === "success" && (
              <div className="contact-alert contact-alert--success" role="alert">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                Message sent successfully — I'll be in touch soon!
              </div>
            )}

            {status === "error" && (
              <div className="contact-alert contact-alert--error" role="alert">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
                Failed to send. Please try again or reach me directly.
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;